<template>
  <div>

  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  props: [],
  data () {
    return {

    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
